
import { Component, Vue, Emit } from 'vue-property-decorator';
import stores from '@/stores';
import Axios from 'axios';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';
import axiosInstance from '../../../helpers/axios';
import session from '@/stores/Session';

@Component({
  components: {
    SweetModal,
  },
  mixins: [ Clickaway ],
})

export default class AttachImageTo extends Vue {
  response: any = null;
  /**
   * Called when changes need to re-render
   */
  contentUrl: any = '';
  currentFolder: number = 1;

  mounted() {
    this.getImages();
    // this.contentUrl = session.project.contentUrl;
    // console.log(session.project.contentUrl);
  }

  getImages() {
    return stores.Folder.getFolder(1)
      .then((response) => {
        this.response = response;
        this.response.children = this.response.folders.concat(this.response.files);
        // @ts-ignore
        this.$refs.image.$children[0].open();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  back() {
    return stores.Folder.getFolder(this.response.mediaFolderId)
      .then((response) => {
        this.response = response;
        this.response.children = this.response.folders.concat(this.response.files);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  forward(id: number) {
    return stores.Folder.getFolder(id)
      .then((response) => {
        this.currentFolder = id;
        this.response = response;
        this.response.children = this.response.folders.concat(this.response.files);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getHeaders() {
    return stores.File.getHeader();
  }

  sendAttach(res: any, newImage: boolean = false) {
    this.$emit('attach', {result: res, new: newImage});
    this.getImages();
  }

  getFilePath(): string {
    return axiosInstance.defaults.baseURL + stores.File.uploadUrl();
  }

  transmitFinish(files: any, result: any) {
    this.response.files.push(result);
    // TODO: tu naj se le osveži seznam
    this.sendAttach(result, true);
  }

  save() {
    this.$emit('save');
  }

  cancel() {
    // @ts-ignore
    this.$emit('close');
  }

  createFolder() {
    // @ts-ignore
    this.$emit('makeDir', {folderId: this.currentFolder});
  }
}
